<template>
    <span
        class="text-danger float-left mr-1"
        v-if="convenio.idSituacaoConvenio != 9"
    >
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir Ação"
            @click.stop="confirmarExcluir()"
        ></i>
    </span>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {
    props: {
        convenio: Object,
        acao: Object
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Excluir',
                html:
                    'Deseja Excluir a Ação: <strong>' +
                    this.acao.descricao +
                    '</strong> ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.excluirAcoes(this.acao.idAcaoConvenio).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Ação excluída com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizarListaAcoes')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    }
}
</script>
